import { type EditorFieldObject } from './types'
import { type FormFieldType } from '../../Form/utils/types'

/**
 * Generates a new Text-EditorFieldObject.
 * @param key React list-render-key
 * @param label Label of the form field
 * @param required
 * @param multiline Enables a multilne text input when set to true.
 * @returns
 */
export function generateTextField(
  key: string | number,
  label: string,
  required = false,
  multiline = false
): EditorFieldObject {
  return {
    type: multiline ? 'multiline' : 'text',
    key: key,
    label: label,
    required: required,
    value: null,
    onChange: () => null,
  }
}

/**
 * Generates a new form field with a 'Add new form field' button.
 * @returns
 */
export function generateAddFormFieldButton(): EditorFieldObject {
  return { type: 'addFormField' }
}

/**
 * Generates a new SectionTitle-EditorFieldObject.
 * @param key React list-render key.
 * @param title The title to display for the next section
 * @returns
 */
export function generateSectionTitle(key: string | number, title: string): EditorFieldObject {
  return {
    type: 'sectionTitle',
    key: key,
    label: title,
    value: undefined,
  }
}

export function generateAddSectionTitleButton(): EditorFieldObject {
  return { type: 'addSectionTitle' }
}

/**
 * Takes a list of EditorFieldObjects and cleans it up such that it can be rendered
 * by our Form component.
 * @param json The list of EditorFieldObjects to clean up.
 */
export function cleanUpFormFields(formFields: EditorFieldObject[]): FormFieldType[] {
  const cleanedUpFormFields = formFields
    .filter(
      // remove the 'addFormField' entry
      (field: EditorFieldObject) =>
        field.type !== 'addFormField' && field.type !== 'addSectionTitle'
    )
    .map(
      // provide meaningful keys and convert EditorFieldObjects to FormFieldType
      (fieldObj: EditorFieldObject) => {
        if (fieldObj.type !== 'addFormField' && fieldObj.type !== 'addSectionTitle') {
          return {
            ...fieldObj,
            // remove all space-like characters and convert the label to all lower case
            key: fieldObj.label.replace(/\s/g, '_').replace(/\./g, '').toLowerCase(),
            // include the required field
            // required: fieldObj.required ?? false,
            // specify render size
            xl: 12,
          } as FormFieldType
        }
      }
    )
  return cleanedUpFormFields as FormFieldType[]
}
